import { configureStore } from '@reduxjs/toolkit';

import reducer from './slices';

export default configureStore({ reducer });

export { sliceActions as actions } from './slices';
export { sliceGetters as getters } from './slices';
